import { createStore as _createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import { persistState } from 'redux-devtools';
import { promiseMiddleware } from '../shared/promiseMiddleware';
import reducers from './reducers/index.js';

const createStore = (data = undefined) => {
    let devTools = [];
    let reduxMiddleware;
    if (__DEVELOPMENT__ && __CLIENT__) {
        devTools = [
            window.devToolsExtension ? window.devToolsExtension() : f => f,
            persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/))
        ];

        reduxMiddleware = applyMiddleware(promiseMiddleware, createLogger());

    } else {
        reduxMiddleware = applyMiddleware(promiseMiddleware);
    }

    const store = _createStore(reducers,
                               data,
                               compose(reduxMiddleware,
                                       ...devTools));

    // Reducer HMR is handled by @vitejs/plugin-react Fast Refresh; no
    // webpack-specific module.hot wiring needed.

    return store;
};

let initialState = __CLIENT__ ? window.__INITIAL_STATE__ : undefined;
export const store = createStore(initialState);